const initialState = [];

const colors = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'FILL_COLORS':
      return payload;

    default:
      return state;
  }
}

export default colors;